export const navLinks = [
  {
    id: 3,
    title: "Shop",
    link: "/search",
  },
  {
    id: 1,
    title: "Group Buy",
    link: "/group-buy",
  },
  {
    id: 1,
    title: "Instabuild Pro",
    link: "/search?instabuild=true",
  },
  {
    id: 2,
    title: "Blogs",
    link: "/blogs",
  },
];
